import { cloneDeep, forEach } from 'lodash'

export default {
  getUniqueProductAttributeValueIdsAllProducts (state, getters) {
    const productAttributes = cloneDeep(getters.getProductAttributeInfoData)
    const uniqueProductAttributeValueIds = {}
    forEach(productAttributes, (attribute) => {
      uniqueProductAttributeValueIds[attribute.attribute_value_id] = true
    })
    return Object.keys(uniqueProductAttributeValueIds).map(key => parseInt(key))
  },
  getUsedAttributeValuesByGroupMerged (state, getters) {
    const uniqueAttrValueIds = getters.getUniqueProductAttributeValueIdsAllProducts

    const selectedFilters = state.allAttributes.filter(item => {
      return item.attributes.filter(sub => {
        return uniqueAttrValueIds.includes(sub.attributeId)
      }).length > 0
    })

    const relatedAttributeData = getters.getRelatedAttributeData

    const uniqueAttrValueIdsMerged = cloneDeep(uniqueAttrValueIds)
    forEach(relatedAttributeData, (product) => {
      forEach(Object.values(product.attributes), (value) => {
        uniqueAttrValueIdsMerged.push(value.attribute_value_id)
      })
    })

    return selectedFilters.map(item => {
      const attributes = item.attributes.filter(sub => {
        return uniqueAttrValueIdsMerged.includes(sub.attributeId)
      })

      const returnItem = JSON.parse(JSON.stringify(item))
      returnItem.attributes = attributes
      return returnItem
    })
  },
  attributeName: (state) => (attributeId) => {
    return state.allAttributes.reduce((acc, item) => {
      const attribute = item.attributes.find(sub => sub.attributeId === attributeId)
      if (attribute) {
        acc = attribute.attributeName
      }
      return acc
    }, '')
  },
  getRelatedAttributeData: state => state.relatedAttributeData,
  getAttributesActive: state => state.attributesActive,
  getListingAttributeGroupCombos: state => state.listingAttributeGroupCombos,
  getDuplicateAttributeGroupNamesPerGroup (state, getters) {
    const listingAttributeGroupCombos = cloneDeep(getters.getListingAttributeGroupCombos)
    const duplicateAttributeGroupNamesPerGroup = {}
    forEach(listingAttributeGroupCombos, (group) => {
      const groupNames = group.attributes.map(item => item.attributeName)
      const duplicateNames = groupNames.filter((item, index) => groupNames.indexOf(item) !== index)
      if (duplicateNames.length <= 0) {
        return []
      }
      forEach(duplicateNames, (name) => {
        if (!duplicateAttributeGroupNamesPerGroup[group.attributeGroupId]) {
          duplicateAttributeGroupNamesPerGroup[group.attributeGroupId] = []
        }
        duplicateAttributeGroupNamesPerGroup[group.attributeGroupId].push({
          duplicateName: name.replaceAll(' ', ''),
          duplicateCount: groupNames.filter(item => item === name).length,
          ids: group.attributes.filter(item => item.attributeName === name).map(item => item.attributeId)
        })
      })
    })
    return duplicateAttributeGroupNamesPerGroup
  },
  getListingAttributeGroupCombosWithoutDuplicateValueNames (state, getters) {
    const duplicateAttributeGroupNamesPerGroup = cloneDeep(getters.getDuplicateAttributeGroupNamesPerGroup)
    const getListingAttributeGroupCombos = cloneDeep(getters.getListingAttributeGroupCombos)
    forEach(getListingAttributeGroupCombos, (group) => {
      const duplicateAttributes = duplicateAttributeGroupNamesPerGroup[group.attributeGroupId]
      if (!duplicateAttributes) {
        return []
      }
      forEach(duplicateAttributes, (attribute) => {
        const attributeIds = attribute.ids
        attributeIds.shift()
        group.attributes = cloneDeep(group.attributes.filter((item) => {
          return !attributeIds.includes(item.attributeId)
        }))
      })
    })
    return getListingAttributeGroupCombos
  },
  getAttributeFilterQueryStringVar: state => state.attributeFilterQueryStringVar,
  getActiveAttributeFilters: state => state.activeAttributeFilters,
  getActiveAttributeFiltersString (state, getters) {
    if (getters.getActiveAttributeFilters.length <= 0) {
      return ''
    }
    return `${getters.getAttributeFilterQueryStringVar}[]=${getters.getActiveAttributeFilters.join(`&${getters.getAttributeFilterQueryStringVar}[]=`)}`
  },
  getActiveAttributeFiltersValueIds: (state) => {
    return state.activeAttributeFilters.map((id) => {
      const regex = /(\d+)/g
      const matches = id.match(regex)
      return Number(matches[0])
    })
  },
  getAttributeRecordsUsed: state => state.attributeRecordsUsed,
  getProductAttributeInfoData: state => state.productAttributeInfoData,
  getAttributeMergeDuplicateValuesByName: state => state.attributeMergeDuplicateValuesByName
}
